

































import { computed, defineComponent, PropType, useRoute } from '@nuxtjs/composition-api';
import BaseCarouselItem from '@shared/components/@molecules/BaseCarouselItem/BaseCarouselItem.vue';
import BaseCarousel from '@shared/components/@organisms/BaseCarousel/BaseCarousel.vue';
import { isAbsoluteUrl, sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';

import WebsiteBannerCountdown from './internal/WebsiteBannerCountdown.vue';
import { UCWebsiteBannerSlide } from './types';

export default defineComponent({
  name: 'UCWebsiteBanner',
  components: {
    BaseCarousel,
    BaseCarouselItem,
    WebsiteBannerCountdown,
  },
  props: {
    slides: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  setup() {
    const route = useRoute();

    const carouselSettings = computed(() => ({
      type: 'carousel',
      perView: 1,
      autoplay: 5000,
      rewind: true,
      gap: 0,
      animationDuration: 1000,
      breakpoints: {
        [576]: {
          perView: 1,
          peek: {
            before: 0,
            after: 0,
          },
        },
        [768]: {
          perView: 1,
          peek: {
            before: 0,
            after: 0,
          },
        },
        [1200]: {
          perView: 1,
          peek: {
            before: 0,
            after: 0,
          },
        },
      },
    }));

    const showCountdown = (slide: UCWebsiteBannerSlide) => !!slide?.countdownTime;

    const getBannerLink = (slide: UCWebsiteBannerSlide) => {
      if (slide?.link) return sanitizeLinkUrl(slide.link);
      if (route.value) return route.value.fullPath;
      return '#';
    };

    const anchorElement = (slide: UCWebsiteBannerSlide) =>
      isAbsoluteUrl(slide?.link) ? 'a' : 'nuxt-link';

    return {
      carouselSettings,
      showCountdown,
      getBannerLink,
      anchorElement,
    };
  },
});
